/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === "a") {
      return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getFullYear() +
      "年" +
      (d.getMonth() + 1) +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}
//操作备注截取
export function opercopy(str) {
  if (str == "" || str == null) {
    return str;
  } else {
    if (str.length > 30) {
      var duan = str.substring(0, 30) + "....";
      return duan;
    } else {
      return str;
    }
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function(...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}
// 资金千位符
export function toThousands(num) {
  // num = this.toNonExponential(Number(num))
  var decimal = String(num).split(".")[1] || ""; //小数部分
  var tempArr = [];
  var revNumArr = String(num)
    .split(".")[0]
    .split("")
    .reverse(); //倒序
  for (let i in revNumArr) {
    tempArr.push(revNumArr[i]);
    if ((i + 1) % 3 === 0 && i != revNumArr.length - 1) {
      tempArr.push(",");
    }
  }
  var zs = tempArr.reverse().join(""); //整数部分
  return decimal ? zs + "." + decimal : zs;
}

// 科学计数法问题处理
export function toNonExponential(num) {
  var m = Number(num)
    .toExponential()
    .match(/\d(?:\.(\d*))?e([+-]\d+)/);
  return Number(num).toFixed(Math.max(0, (m[1] || "").length - m[2]));
}

export function fixNumberCopy (value, unit) {
  var str = typeof value == 'string' ? value : value + ''
  var isDecimal = str.indexOf('.') != -1
  var str1 = ''
  var str2 = ''
  var result = ''
  if (unit && unit != 0) {
    if (isDecimal) {
      str1 = str.split('.')[0]
      str2 = str.split('.')[1]
      if (str2.length >= unit) {
        str2 = str2.slice(0, unit)
      } else {
        var num = unit - str2.length
        for (var i = 0; i < num; i++) {
          str2 += '0'
        }
      }
      result = str1 + '.' + str2
    } else {
      for (var i = 0; i < unit; i++) {
        str2 += '0'
      }
      result = str + '.' + str2
    }
  } else {
    result = isDecimal ? str.split('.')[0] : str
  }
  return result
}

/**svg组件校验传入的iconClass是否为外部链接
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}



// WEBPACK FOOTER //
// ./src/utils/index.js